import { atom } from "recoil";

export const bonusesEditModalStore = atom({
	key: "bonusesEditModalStore",
	default: {
		show: false,
		id: 0,
		loaded: true,
		isPublic: false,
		type: false,
		count: "",
		uid: "",
		value: "",
		note: "",
		name: "",
		reason: null,
		reasonIdentifier: '',
		editAll: false,
		oldNote: "",
		bonusCode: '',
		advancedSettingsEnabled: false,
		bonusAmount: '',
		bonusMode: 0,
		depositPercent: '',
		depositApplyLimit: '',
		minDeposit: '',
		maxDeposit: '',
		maxBonusAmount: '',
		bonusType: { label: 'All', value: 'all' },
		wager: null,
		taskCount: '',
		taskDays: '',
		showWagerConfirmation: false,
		maxWithdrawal: '',
		depositTo: '',
		depositFrom: '',
		depositCount: '',
		description: {},
		emailChecked: false,
		phoneChecked: false,
		tgChecked: false,
		verifiedChecked: false,
		otherPromoActivated: false,
		otherPromoAmount: '',
		otherPromoDateFrom: null,
		otherPromoDateTo: null,
		otherPromoDateType: '',
		activation_lifetime_days: '',
		promoDateFrom: null,
		promoDateTo: null,
		promoDateType: '',
		considerBetAmount: false,
		betAmount: '',
		betDateFrom: null,
		betDateTo: null,
		betDateType: '',
		trafficType: '',
		trafficSource: '',
		adCostTotal: '',
		adPayments: [],
		validityPeriod: null,
		vipLevelMode: null,
		vipLevel: '',
		lastDepositDateFrom: null,
		lastDepositDateTo: null,
		lastDepositDateType: "",
		playerIds: '',
		errors: {},
		checked: false,
	},
});
